/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ToDoTaskRow } from './ToDoTaskRow';
import {
    ToDoTaskRowFromJSON,
    ToDoTaskRowFromJSONTyped,
    ToDoTaskRowToJSON,
    ToDoTaskRowToJSONTyped,
} from './ToDoTaskRow';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface ToDoWidgetData
 */
export interface ToDoWidgetData {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof ToDoWidgetData
     */
    total: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {Array<ToDoTaskRow>}
     * @memberof ToDoWidgetData
     */
    items: Array<ToDoTaskRow>;
}

/**
 * Check if a given object implements the ToDoWidgetData interface.
 */
export function instanceOfToDoWidgetData(value: object): value is ToDoWidgetData {
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function ToDoWidgetDataFromJSON(json: any): ToDoWidgetData {
    return ToDoWidgetDataFromJSONTyped(json, false);
}

export function ToDoWidgetDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ToDoWidgetData {
    if (json == null) {
        return json;
    }
    return {
        
        'total': ApiUserTasksGetPageParameterFromJSON(json['total']),
        'items': ((json['items'] as Array<any>).map(ToDoTaskRowFromJSON)),
    };
}

export function ToDoWidgetDataToJSON(json: any): ToDoWidgetData {
    return ToDoWidgetDataToJSONTyped(json, false);
}

export function ToDoWidgetDataToJSONTyped(value?: ToDoWidgetData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'total': ApiUserTasksGetPageParameterToJSON(value['total']),
        'items': ((value['items'] as Array<any>).map(ToDoTaskRowToJSON)),
    };
}

